var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RoundButton',{style:({
    position: 'initial',
    bottom: 'initial',
    right: 'initial',
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }